import { Divider, Grid, Typography } from "@mui/material"
import logohorizontal from '../image/logovertical.png'
function Dashboard(params) {
    return (
        <Grid container>
            <Grid size={{ xs: 12, md: 12 }}>
                <div className="logoDashboard">
                    <img src={logohorizontal} alt="" />
                </div>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <Divider style={{margin: "10px 0"}} />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <Typography variant="h5" align="center" sx={{fontWeight: "bold"}}>Control de Cotizaciones</Typography>
            </Grid>
        </Grid>
    )
}

export default Dashboard